import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=3089a6de&scoped=true&"
import script from "./Revenue.vue?vue&type=script&lang=js&"
export * from "./Revenue.vue?vue&type=script&lang=js&"
import style0 from "./Revenue.vue?vue&type=style&index=0&id=3089a6de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3089a6de",
  null
  
)

export default component.exports